/* tslint:disable */

declare var Object: any;
export interface JobPrescreenInterface {
  "sfdcId"?: string;
  "ts2__Answer__c"?: string;
  "ts2__Answer_ID__c"?: string;
  "ts2__Answer_Txt__c"?: string;
  "ts2__Application__c"?: string;
  "ts2__Business_Unit__c"?: string;
  "ts2__Originating_Prescreen__c"?: string;
  "ts2__Question__c"?: string;
  "ts2__Question_ID__c"?: string;
  "ts2__Question_Set__c"?: string;
  "ts2__Question_Size__c"?: string;
  "ts2__Rich_Text_Question__c"?: string;
  "ts2__Rollover__c"?: boolean;
  "ts2__Score__c"?: number;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class JobPrescreen implements JobPrescreenInterface {
  "sfdcId": string;
  "ts2__Answer__c": string;
  "ts2__Answer_ID__c": string;
  "ts2__Answer_Txt__c": string;
  "ts2__Application__c": string;
  "ts2__Business_Unit__c": string;
  "ts2__Originating_Prescreen__c": string;
  "ts2__Question__c": string;
  "ts2__Question_ID__c": string;
  "ts2__Question_Set__c": string;
  "ts2__Question_Size__c": string;
  "ts2__Rich_Text_Question__c": string;
  "ts2__Rollover__c": boolean;
  "ts2__Score__c": number;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: JobPrescreenInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `JobPrescreen`.
   */
  public static getModelName() {
    return "JobPrescreen";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of JobPrescreen for dynamic purposes.
  **/
  public static factory(data: JobPrescreenInterface): JobPrescreen{
    return new JobPrescreen(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'JobPrescreen',
      plural: 'JobPrescreens',
      path: 'JobPrescreens',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "ts2__Answer__c": {
          name: 'ts2__Answer__c',
          type: 'string'
        },
        "ts2__Answer_ID__c": {
          name: 'ts2__Answer_ID__c',
          type: 'string'
        },
        "ts2__Answer_Txt__c": {
          name: 'ts2__Answer_Txt__c',
          type: 'string'
        },
        "ts2__Application__c": {
          name: 'ts2__Application__c',
          type: 'string'
        },
        "ts2__Business_Unit__c": {
          name: 'ts2__Business_Unit__c',
          type: 'string'
        },
        "ts2__Originating_Prescreen__c": {
          name: 'ts2__Originating_Prescreen__c',
          type: 'string'
        },
        "ts2__Question__c": {
          name: 'ts2__Question__c',
          type: 'string'
        },
        "ts2__Question_ID__c": {
          name: 'ts2__Question_ID__c',
          type: 'string'
        },
        "ts2__Question_Set__c": {
          name: 'ts2__Question_Set__c',
          type: 'string'
        },
        "ts2__Question_Size__c": {
          name: 'ts2__Question_Size__c',
          type: 'string'
        },
        "ts2__Rich_Text_Question__c": {
          name: 'ts2__Rich_Text_Question__c',
          type: 'string'
        },
        "ts2__Rollover__c": {
          name: 'ts2__Rollover__c',
          type: 'boolean'
        },
        "ts2__Score__c": {
          name: 'ts2__Score__c',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
